import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./ActiveList.css";
import { ServicegetCommunicationAudio, get_link } from "../Services/Service";
import Table from "./DataTable/DataTable";
import { CustomLoader, ModalBox } from "../Services/CommonLibrary";

const queryParams = new URLSearchParams(window.location.search);
const status = queryParams.get("status");

function CommunicationAudio() {
  const clickhandler = (name) => console.log("delete", name);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const startIndex = (currentPage - 1) * 50;

  const [serviceData, setServiceData] = useState([]);
  var storage = JSON.parse(localStorage.getItem("programDetail"))
    ? JSON.parse(localStorage.getItem("programDetail"))
    : 0;
  let programId = storage.programId;
  const nav = useNavigate();
  const accessFrom = localStorage.getItem("access");

  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalType, setModalType] = useState("");
  const handleClose = () => setShowModal(false);

  const [encId, setEncId] = useState("");

  useEffect(() => {
    fetchProgramDetails("onboarded");
  }, []);

  const fetchProgramDetails = async (filterStatus) => {
    ServicegetCommunicationAudio(filterStatus).then((res) => {
      setServiceData(res.data.data.communicationlist);
      setLoading(false);
    });
  };

  const openPopup = async (url, type, id) => {
    console.log("id", id);
    const response = await get_link(id,"audio");
    console.log("response",response);
    if(!response.data.data.compositionUrl) return false;
    if (response.data.code === 200 && response.data.data.compositionUrl!='') {
      url = response.data.data.compositionUrl; // Update the URL with the one from the response
      //console.log("url",url);
    } else {
      throw new Error("Invalid response or missing compositionUrl");
    }
    const videoHtml = (
      <>
        <video src={url} controls={true} autoPlay={true} />
      </>
    );
    const audioHtml = (
      <audio
        src={url}
        controls={true}
        autoPlay={true}
        style={{ height: "80px" }}
      />
    );
    const phtml = type == "video" ? videoHtml : audioHtml;
    setModalTitle("Recording");
    setModalType("md");
    setModalBody(phtml);
    setShowModal(true);
  };

  const columns = [
    {
      name: "#",
      cell: (row, index) => startIndex + index + 1,
      sortable: false,
      grow: 0,
    },
    {
      id: 2,
      name: <div className="tdData text-start">Patient Name</div>,
      selector: (row) => row.patientName,
      cell: (row) => <div className="tdData">{row.patientName}</div>,
      sortable: true,
    },
    {
      id: 3,
      name: <div className="tdData text-start">Coach Name</div>,
      selector: (row) => row.coachName,
      cell: (row) => <div className="tdData">{row.coachName}</div>,
      sortable: true,
    },
    {
      id: 4,
      name: <div className="tdData text-start">Mobile</div>,
      selector: (row) => row.mobile,
      cell: (row) => <div className="tdData">{row.mobile}</div>,
      sortable: true,
    },
    {
      id: 5,
      name: <div className="tdData text-start">Date Time</div>,
      selector: (row) => row.createdTime,
      cell: (row) => <div className="tdData">{row.createdTime}</div>,
      sortable: true,
    },
    {
      id: 6,
      name: <div className="tdData text-start">Duration</div>,
      selector: (row) => row.duration,
      cell: (row) => <div className="tdData">{row.duration}</div>,
      sortable: true,
    },
    {
      id: 7,
      name: <div className="tdData text-start">Status</div>,
      selector: (row) => row.status,
      cell: (row) => <div className="tdData">{row.status}</div>,
      sortable: true,
    },
    {
      id: 8,
      name: "Recording", //Consultation Notes
      button: true,
      omit: accessFrom == "superadmin" ? false : true,
      cell: (row) =>
        accessFrom == "superadmin" ? (
          <div>
            <button
              className="btn btn-primary btn-sm "
              onClick={(e) => openPopup(row.compositionUrl, row.type, row.id)}
            >
              Play
            </button>
          </div>
        ) : null,
    },
  ];

  const onChangePage = (page) => {
    setCurrentPage(page);
  };

  const DataTableTitle = <></>;
  return (
    <section className="">
      <div className="row">
        <div className="FL">
          <div className="table-responsive">
            <Table
              data={serviceData}
              column={columns}
              title={DataTableTitle}
              click={clickhandler}
              onChangePage={onChangePage}
            />
          </div>
        </div>
      </div>
      {loading ? <CustomLoader /> : null}
      {showModal ? (
        <ModalBox
          handleClose={handleClose}
          showModaln={showModal}
          titlen={modalTitle}
          type={modalType}
          bodyn={modalBody}
        />
      ) : (
        ""
      )}
    </section>
  );
}
export default CommunicationAudio;
